import { Dropdown } from 'react-bootstrap';
import styled from 'styled-components';

const StyledDropdownItem = styled(Dropdown.Item)`
    padding: 4px 12px;
`;

export default StyledDropdownItem;
